import { render, staticRenderFns } from "./ShareItemIcon.vue?vue&type=template&id=5925d267&scoped=true"
import script from "./ShareItemIcon.vue?vue&type=script&lang=js"
export * from "./ShareItemIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5925d267",
  null
  
)

export default component.exports